import { useContext } from 'react'
import { CheckoutContext } from 'lib/core/resources/context'

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext)
  if (context === undefined) {
    throw new Error('useCheckoutContext must be used within a CheckoutProvider')
  }
  return context
}
